export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6347.f2e847e0.jpg";